import * as React from 'react';

export const SliderButton = ({ scrollRef, scrollDirectionLtR, scrollX = 135, updateFadeVisibility  }: {scrollRef: React.RefObject<any>, scrollDirectionLtR?: boolean, scrollX?: number, updateFadeVisibility?:any}) => {
    const [isClicked, setIsClicked] = React.useState(false)
    const [scrollInterval, setScrollInterval] = React.useState(null)

    const handleScroll = (scrollRef: React.RefObject<any>) => {
       if(!isClicked && scrollRef) {
            setScrollInterval(setInterval(() => {
                if(!scrollDirectionLtR) {
                    scrollRef.current.scrollBy({top: 0, left: scrollX, behavior: 'smooth'})
                    updateFadeVisibility && updateFadeVisibility(scrollRef.current.scrollLeft + scrollX)
                }
                if(scrollDirectionLtR) {
                    scrollRef.current.scrollBy({top: 0, left: -scrollX, behavior: 'smooth'})
                    updateFadeVisibility && updateFadeVisibility(scrollRef.current.scrollLeft - scrollX)
                }

            }, 50))
            setIsClicked(true)
        }
    }
    const handleReleaseScroll = () => {
        setIsClicked(false)
        clearInterval(scrollInterval)
    }


    return (<button type="button"
                    className={`destination__stats__scrollBtn ${scrollDirectionLtR && 'destination__stats__scrollBtn--right'}`}
                    onMouseDown={() => handleScroll(scrollRef)}
                    onMouseUp={handleReleaseScroll}
                    onTouchStart={() => handleScroll(scrollRef)}
    />)
}